<template>
  <div v-if="attributes != null" id="show-attributes-card">
    <v-card class="mt-3">
      <v-card-title> Attributs </v-card-title>
      <v-card-text>
        <attribute-datatable
          :attributes="attributes"
          :is-loading="isLoading"
          :first-load="firstLoad"
          :partner="partner"
        ></attribute-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import AttributeDatatable from "@/components/Attribute/AttributeDatatable";
import { useAttributes } from "@/composables/attribute";

export default {
  components: { AttributeDatatable },
  props: {
    partner: Object,
  },
  setup(props) {
    const { attributes, listAttributes, attributeData } = useAttributes();
    onMounted(() => {
      listAttributes(null, null, props.partner.id);
    });

    return {
      attributes,
      ...toRefs(attributeData),
    };
  },
};
</script>
